import Loader from "components/Loader";
import { _ } from "i18n";
import React from "react";

interface LoadMoreSectionProps {
    isLoading: boolean, 
    shouldShowLoadMore: boolean, 
    onLoadMore: () => void
}

export const LoadMoreSection: React.FC<LoadMoreSectionProps> = ({ isLoading, shouldShowLoadMore, onLoadMore }) => {
    return (
        <>
            {shouldShowLoadMore && (
                <div className="text-center">
                    <button
                        className="btn btn-light-blue"
                        onClick={onLoadMore}
                        >
                            {_("btn.load_more")}
                        </button>
                    </div>
                )}
        </>
    )
}